import React, { Component } from 'react';
import Helpful from './Helpful';
import Report from './Report';
import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import styles from './ReviewFeedbackBar.module.scss';

type Props = {
    helpfulCount: number;
    openReportReviewModal: Function;
    reviewId: number;
    setBidderReviewStatus: Function;
    statuses: any;
    submitted: boolean;
};

export default class ReviewFeedbackBar extends Component<Props> {
    helpfulClick = () => {
        this.props.setBidderReviewStatus({
            active: !this.props.statuses.includes('helpful'),
            reviewId: this.props.reviewId,
            reviewStatus: 'helpful',
        });
    };

    reportClick = () => {
        this.props.openReportReviewModal(this.props.reviewId);
    };
    render() {
        const { helpfulCount, statuses, submitted } = this.props;
        const isHelpful = statuses.includes('helpful');
        const isReported = statuses.includes('reported');

        const reportClick = isReported ? null : this.reportClick;
        return (
            <div className={styles.container}>
                <ShouldLogInContainer requireLogin runFunction={this.helpfulClick}>
                    <Helpful
                        active={isHelpful}
                        className={styles.helpful}
                        count={helpfulCount}
                        key="helpful"
                        onClick={this.helpfulClick}
                        submitted={submitted}
                    />
                </ShouldLogInContainer>
                <ShouldLogInContainer requireLogin runFunction={reportClick}>
                    <Report active={isReported} className={styles.report} key="report" onClick={reportClick} />
                </ShouldLogInContainer>
            </div>
        );
    }
}
